<template>
  <EventPopupModal @close="onClose">
    <template #body>
      <div class="event-popup-result">
        <div class="event-popup-result__heading">
          申込みが完了しました。
          <div class="event-popup-result__heading-sub">日程の変更やキャンセルはマイページをご確認ください</div>
        </div>
        <div class="event-popup-result__event-title-section">
          <span class="event-popup-result__event-title">
            {{ item.event.title }}
          </span>
          <div class="event-popup-result__event-category">
            {{ categoryText }}
          </div>
        </div>
        <div v-if="hasPlace || formattedScheduleTime" class="event-popup-result__place-time">
          <div v-if="hasPlace" class="event-popup-result__place">
            <InlineSvg
              v-if="isOnline"
              :src="require('../../../images/public.svg')"
              class="event-popup-result__place-time-icon"
            />
            <InlineSvg
              v-else
              :src="require('../../../images/location_on.svg')"
              class="event-popup-result__place-time-icon"
            />
            {{ schedule.place }}
          </div>
          <div v-if="formattedScheduleTime" class="event-popup-result__time">
            <InlineSvg :src="require('../../../images/calendar.svg')" class="event-popup-result__place-time-icon" />
            {{ formattedScheduleTime }}
          </div>
        </div>
      </div>
    </template>
  </EventPopupModal>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from '@vue/composition-api';
import { EventPopupItem, EventSchedule } from 'oc2api/popup';
import { eventCategoryToText, isOnlineSchedule, formatScheduleTime } from 'utils/event';
import EventPopupModal from './EventPopupModal.vue';

export default defineComponent({
  name: 'EventPopupEntryResultModal',
  components: {
    EventPopupModal,
  },
  props: {
    item: {
      type: Object as PropType<EventPopupItem>,
      required: true,
    },
    schedule: {
      type: Object as PropType<EventSchedule>,
      required: true,
    },
  },
  emits: {
    close: () => true,
  },
  setup(props, { emit }) {
    const categoryText = computed(() => eventCategoryToText(props.item.event.category));
    const hasPlace = computed(() => props.schedule.place != null && props.schedule.place !== '');
    const isOnline = computed(() => isOnlineSchedule(props.schedule));
    const formattedScheduleTime = computed(() => formatScheduleTime(props.schedule));
    const onClose = () => {
      emit('close');
    };
    return {
      categoryText,
      hasPlace,
      isOnline,
      formattedScheduleTime,
      onClose,
    };
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';
@import 'stylesheets/variables';

.event-popup-result {
  padding: 64px 40px 54px;

  @media screen and (max-width: 768px) {
    padding: 48px 16px 40px;
  }
}

.event-popup-result__heading {
  font-weight: 600;
  font-size: 34px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: $oc-black;

  @media screen and (max-width: 768px) {
    font-size: 24px;
  }
}

.event-popup-result__heading-sub {
  font-weight: 400;
  font-size: 10px;
  line-height: 150%;
  letter-spacing: 0.02em;
  color: $oc-gray60;
}

.event-popup-result__event-title-section {
  margin-top: 40px;
}

.event-popup-result__event-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  color: $oc-black;
}

.event-popup-result__event-category {
  display: inline-block;
  padding: 5px 12px 4px;
  background-color: $oc-area-bg;
  border-radius: 14px;

  font-weight: 600;
  font-size: 10px;
  line-height: 150%;
  letter-spacing: 0.02em;
  color: $oc-gray80;
}

.event-popup-result__place-time {
  margin-top: 8px;
  padding: 8px 0 8px 17px;
  border-left: 4px solid $oc-black;
  font-weight: 400;
  font-size: 14px;
  line-height: 172%;
  letter-spacing: 0.02em;
  color: $oc-black;
}

.event-popup-result__place,
.event-popup-result__time {
  display: flex;
  align-items: center;
}

.event-popup-result__place-time-icon {
  flex: none;
  height: 15px;
  margin-right: 8px;
}
</style>
